import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import withRoot from './withRoot';
import RetailerInfo from './RetailerInfo';
import Authenticate from './Authenticate';
import OpenInvoices from './OpenInvoices';
import InvoiceInfo from './InvoiceInfo';
import CreditMemoInfo from './CreditMemoInfo';
import NoMatch from './NoMatch';
import ThankYou from './ThankYou';
import GabrielCircleIcon from './GabrielCircleIcon';
import requireAuth from './require_auth';
import color from '@material-ui/core/colors/indigo';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: '100px',
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
    width: '15%',
    zIndex: 9999,
    marginTop: -80,
    marginLeft: 5,
    position: 'fixed',
  },
  cardMobile: {
    display: 'flex',
    justifyContent: 'center',
    zIndex: 9999,
    marginTop: -50,
    width: window.innerWidth > 768 ? '' : window.innerWidth <= 320 ? '156%' : window.innerWidth <= 400 ? '130%' : '115%',
    margin: '1%',
 },
  cardTab: {
    display: 'flex',
    zIndex: 9999,
    marginTop: -80,
    justifyContent: 'center',
    margin: '1%',
    position: 'fixed',
    width: '25%',
  },
  appBar: {
    paddingTop: 'env(safe-area-inset-top)',
  },
  wrapper: {
    padding: 4,
    [theme.breakpoints.up('sm')]: {
     // paddingTop: 104,
    }
  },
  gabrielCircleIcon: {
    height: 48,
    width: 48,
  },
  header: {
    fontFamily: "'Averia Serif Libre', cursive",
    fontSize: '22px',
    fontWeight: '100',
    color: 'black'
  },
  paymentPortal: {
    alignSelf: 'center',
    flex: 1,
    height: 80,
    padding: 4,
    textAlign: 'center',
    fontSize: 20,
    fontFamily: "'Averia Serif Libre', cursive",
    color:'#fa451c',
    backgroundSize: 'cover',
    '-webkit-background-clip': 'text',
  }
});

class App extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar} style={{boxShadow: 'none'}}>
          <Toolbar style={{background: 'white', borderBottom: '1px solid #fa451c'}}>
          
            <GabrielCircleIcon className={classes.gabrielCircleIcon}  /> 
            {/* <h2 className={classes.header} style={window.innerWidth > 768 ? {display: 'flex',justifyContent: 'center',width: '70%'} : {} }>
                Payment Portal
              </h2> */}
          </Toolbar>
        </AppBar>
        <Card className={window.innerWidth > 768 ? classes.card : window.innerWidth >= 768 && window.innerWidth <= 1024 ? classes.cardTab : classes.cardMobile} >
          <Typography variant="subheading" component="h3" className={classes.paymentPortal}>
            <span style={{color:"#fa451c", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>Payment Portal</span><br/>
          </Typography>
        </Card>
        <RetailerInfo />
        <main className={classes.wrapper} style={window.innerWidth > 768 ? {} : window.innerWidth <= 320 ? { width: '156%' } : window.innerWidth <= 400 ? { width: '130%' } : { width: '115%' }}>
          <Switch>
            <Route
              exact path="/"
              render={props => <Redirect to='/authenticate'/> }
            />
             <Route exact path="/authenticate/:token?/*" component={Authenticate} />
            <Route exact path="/authenticate/:token?/:code?" component={Authenticate} />
            <Route exact path="/open-invoices" component={requireAuth(OpenInvoices)} />
            <Route exact path="/invoice-info/*" component={requireAuth(InvoiceInfo)} />
            <Route exact path="/creditmemo-info/*" component={requireAuth(CreditMemoInfo)} />
            <Route exact path="/success" component={ThankYou} />
          </Switch>
        </main>
        {/* <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
        <button onClick={this.simpleAction}>Test redux action</button>
        <pre>
          {
            JSON.stringify(this.props)
          }
        </pre> */}
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(App));


// WEBPACK FOOTER //
// ./src/App.js